import { createStore } from "redux";
import rootReducer from "../reducers/reducers";

export default createStore(rootReducer);
